
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transaction_transfer_v2",
      function () {
        return require("private-next-pages/transaction_transfer_v2.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transaction_transfer_v2"])
      });
    }
  